import { Provider } from 'react-redux'
import { Outlet } from 'react-router-dom'
import { ContractWalletBlocker } from './components/ContractWalletBlocker'
import { ErrorBoundary } from './components/ErrorBoundary'
import { ErrorPage } from './pages/ErrorPage/ErrorPage'
import { logAppVersions } from './services/apiService'
import { AuthProvider } from './services/auth/AuthContext'
import { translationSetup } from './services/translationService'
import { configureStore } from './store/configureStore'
import { GlobalStyle } from './styles/GlobalStyle'
import { RhinoThemeProvider } from './components/RhinoThemeProvider'
import { themes } from './theme'
import { Suspense } from 'react'
import { AppLoader } from './components/common/Helpers/AppLoader'
import { Helmet } from 'react-helmet'
import { translate } from './intl/i18n'
import { WalletProvider } from './components/WalletProvider'
import { listenForViteEvents } from './utils/listenForViteEvents'

const store = configureStore()

logAppVersions()

translationSetup()
listenForViteEvents()

export const Root = () => {
  return (
    <ErrorBoundary fallback={(error) => <ErrorPage error={error} theme={themes['rhino']} />}>
      <Provider store={store}>
        <Suspense fallback={<AppLoader showOnPage showLogo source="suspense-app" />}>
          <WalletProvider>
            <RhinoThemeProvider>
              <Helmet>
                <title>{translate('metadata.title_default')}</title>
                <meta name="description" content={translate('metadata.description_default')} />
              </Helmet>
              <GlobalStyle />
              <AuthProvider>
                <ContractWalletBlocker />
                <Outlet />
              </AuthProvider>
            </RhinoThemeProvider>
          </WalletProvider>
        </Suspense>
      </Provider>
    </ErrorBoundary>
  )
}
